export default __webpack_public_path__ + "static/media/betterLuckNextTime.102148a3.png";